if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();
				this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

				window.addEventListener("keyup", (event) => {
					if (event.code.toUpperCase() === "ESCAPE") this.hide();
				});

				if (!this._quickAddOutsideClickBound) {
					this._quickAddOutsideClickBound = true;
					document.addEventListener("click", (event) => {
						if (!this.modalContent) return;
						if (this.modalContent.contains(event.target)) return;
						this.modalContent
							.querySelectorAll(".dropdown-select ul.active")
							.forEach((list) => list.classList.remove("active"));
					});
				}

				/*window.addEventListener('resize', function () {
					$('.js-media-list').each(function () {
						this.swiper?.destroy();
					});
					$('.js-media-sublist').each(function () {
						this.swiper?.destroy();
					});

					setTimeout(() => {
						subSliderInit(true);
						sliderInit(true);
					}, 200)
				});*/
			}

			hide(preventFocus = false) {
				const cartDrawer = document.querySelector("cart-drawer");
				if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
				this.modalContent.innerHTML = "";

				document.querySelectorAll(".js-media-list").forEach((element) => {
					element.swiper?.destroy();
				});
				document.querySelectorAll(".js-media-sublist").forEach((element) => {
					element.swiper?.destroy();
				});

				quickAddsliderInit(true);

				if (preventFocus) this.openedBy = null;
				super.hide();
			}

			show(opener) {
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");

				if (opener.querySelector(".loading-overlay__spinner")) {
					opener
						.querySelector(".loading-overlay__spinner")
						.classList.remove("hidden");
				}

				fetch(opener.getAttribute("data-product-url"))
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]'
						);
						this.preventDuplicatedIDs();
						this.removeDOMElements();
						this.setInnerHTML(
							this.modalContent,
							this.productElement.innerHTML,
							opener
						);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.removeGalleryListSemantic();
						this.updateImageSizes();
						this.preventVariantURLSwitching();
						super.show(opener);
					})
					.finally(() => {
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");

						if (opener.querySelector(".loading-overlay__spinner")) {
							opener
								.querySelector(".loading-overlay__spinner")
								.classList.add("hidden");
						}

						document.querySelectorAll(".js-media-list").forEach((element) => {
							element.swiper?.destroy();
						});
						document
							.querySelectorAll(".js-media-sublist")
							.forEach((element) => {
								element.swiper?.destroy();
							});

						quickAddsliderInit(true);

						const selectDropDown = () => {
							this.modalContent
								.querySelectorAll(".product-form__controls--dropdown")
								.forEach((dropdown) => {
									if (dropdown.dataset.dropdownInit === "true") return;
									dropdown.dataset.dropdownInit = "true";

									const elListItem = Array.from(
										dropdown.querySelectorAll(".dropdown-select ul li")
									);
									const elItem = dropdown.querySelector(".dropdown-select ul");
									const selectedText = dropdown.querySelector(
										".dropdown-select .select-label"
									);
									if (!elItem || !selectedText) return;

									selectedText.addEventListener("click", (e) => {
										e.stopPropagation();
										elItem.classList.toggle("active");
									});

									elListItem.forEach((item) => {
										item.addEventListener("click", function () {
											const valueEl =
												this.querySelector(".select-labels__value");
											const input = this.querySelector("input");
											const valueOnly = valueEl
												? valueEl.textContent.trim()
												: (input?.value || "").trim();
											const dropdownFieldset = this.closest(
												".product-form__controls--dropdown"
											);
											const variantRadios = dropdownFieldset
												? dropdownFieldset.closest("variant-radios")
												: null;

											if (
												variantRadios &&
												typeof variantRadios.updateDropdownLabel ===
													"function"
											) {
												variantRadios.updateDropdownLabel(
													dropdownFieldset,
													valueOnly
												);
											}

											elItem.classList.remove("active");
											if (document.activeElement instanceof HTMLElement) {
												document.activeElement.blur();
											}
										});
									});
								});
						};

						selectDropDown();

						const initVariantDropdownFromUrl = () => {
							this.modalContent.querySelectorAll("variant-radios").forEach((variantRadios) => {
								if (typeof variantRadios.initDropdownFromUrl === "function") {
									variantRadios.initDropdownFromUrl();
								}
							});
						};

						initVariantDropdownFromUrl();

						// Convert prices to euros after modal content is loaded
						if (typeof window.convertPricesToEuros === 'function') {
							window.convertPricesToEuros();
						}
					});
			}

			setInnerHTML(element, html, opener) {
				element.innerHTML = html;

				// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML)
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});

				// Read more button
				const moreBtn = document.createElement("a");
				//moreBtn.textContent = `${theme.quickviewMore}`;
				moreBtn.innerHTML = `<span>${theme.quickviewMore}</span>`;
				moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
				moreBtn.setAttribute(
					"class",
					"product__full-details button button--simple"
				);
				element
					.querySelector(".product .product__info-main_content")
					.appendChild(moreBtn);
			}

			removeDOMElements() {
				const modal = this.productElement.querySelector("product-modal");
				if (modal) modal.remove();

				const popup = this.productElement.querySelectorAll(".product-popup");
				if (popup)
					popup.forEach((el) => {
						el.remove();
					});

				const reviews = this.productElement.querySelector(
					'[data-block-handle="reviews"]'
				);
				if (reviews) reviews.remove();

				const about = this.productElement.querySelectorAll(".about");
				if (about)
					about.forEach((el) => {
						el.remove();
					});

				const iconText = this.productElement.querySelectorAll(
					".product__text-icon"
				);
				if (iconText)
					iconText.forEach((el) => {
						el.remove();
					});

				const shareButtons =
					this.productElement.querySelector(".share-buttons");
				if (shareButtons) shareButtons.remove();

				const tags = this.productElement.querySelector(".product-tags");
				if (tags) tags.remove();

				const pickupAvailability = this.productElement.querySelector(
					".pickup-availability"
				);
				if (pickupAvailability) pickupAvailability.remove();

				const description = this.productElement.querySelector(
					".product__description"
				);
				if (description) description.remove();

				const swymAtwButtonContainer = this.productElement.querySelector(".swym-atw-button-container");
				if (swymAtwButtonContainer) swymAtwButtonContainer.remove();

				const customAccordionWrappers = this.productElement.querySelectorAll(".custom-accordion__wrapper");
				if (customAccordionWrappers)
					customAccordionWrappers.forEach((el) => {
						el.remove();
					});

				const recommendations = this.productElement.querySelector(
					"product-recommendations"
				);

				if (recommendations) recommendations.remove();

				const product__popup =
					this.productElement.querySelector(".product__popup");
				if (product__popup) product__popup.remove();
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					);
				this.productElement
					.querySelectorAll("variant-selects, variant-radios")
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId;
					});
			}

			preventVariantURLSwitching() {
				if (this.modalContent.querySelector("variant-radios,variant-selects")) {
					this.modalContent
						.querySelector("variant-radios,variant-selects")
						.setAttribute("data-update-url", "false");
				}
			}

			removeGalleryListSemantic() {
				const galleryList = this.modalContent.querySelector(
					'[id^="Slider-Gallery"]'
				);
				if (!galleryList) return;

				galleryList.setAttribute("role", "presentation");
				galleryList
					.querySelectorAll('[id^="Slide-"]')
					.forEach((li) => li.setAttribute("role", "presentation"));
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes)
				);
			}
		}
	);
}
